import { FetchAttr } from '../types';
import { postData } from '../utils';

type PostNoSearchResultFeedbackPayload = {
  phone: string;
  name?: string;
  searchValue: string;
};

export type PostNoSearchResultFeedbackResponse = {
  status: number;
};

const postNoSearchResultFeedback = async (
  requestObj: PostNoSearchResultFeedbackPayload,
  attr?: FetchAttr
): Promise<PostNoSearchResultFeedbackResponse> => {
  const response = await postData(`search_help`, requestObj, attr);
  return response;
};

export default postNoSearchResultFeedback;
